/*
 * Viewport-gated product-card videos.
 *
 * Why: a collection grid can hold dozens of product videos. Shopify serves each
 * as HLS + a large MP4, so letting them all load autoplays ~200MB and browsers
 * cap simultaneous playback anyway (most just sit paused after downloading).
 *
 * How: each card <video> keeps the native `autoplay muted playsinline` attrs but
 * ships with NO source (sources sit in data-src, preload="none"), so nothing
 * loads on page load. When a card nears the viewport we inject its source and
 * call load() -> native autoplay plays it (same reliable path as the product
 * page, incl. iOS). When it scrolls well away we strip the source and unload it,
 * freeing the decoder so only a few videos are ever live at once.
 */
(function () {
  function addSources(v) {
    var srcs = v.querySelectorAll('source[data-src]');
    for (var i = 0; i < srcs.length; i++) {
      if (!srcs[i].getAttribute('src')) {
        srcs[i].setAttribute('src', srcs[i].getAttribute('data-src'));
      }
    }
  }

  function play(v) {
    v.muted = true; // iOS: muted must be a property for programmatic play
    var p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        // play() can be interrupted by the preceding load(); retry once ready.
        var onReady = function () {
          v.removeEventListener('canplay', onReady);
          var r = v.play();
          if (r && typeof r.catch === 'function') { r.catch(function () {}); }
        };
        v.addEventListener('canplay', onReady);
      });
    }
  }

  function activate(v) {
    if (v.dataset.loaded === '1') { play(v); return; }
    v.muted = true;
    v.setAttribute('muted', '');
    addSources(v);
    v.dataset.loaded = '1';
    v.load();
    // The native autoplay attribute only fires on first load; after a video is
    // released and re-activated we must start it ourselves (muted => allowed).
    play(v);
  }

  function unload(v) {
    if (v.dataset.loaded !== '1') return;
    try { v.pause(); } catch (e) {}
    var srcs = v.querySelectorAll('source');
    for (var i = 0; i < srcs.length; i++) { srcs[i].removeAttribute('src'); }
    v.removeAttribute('src');
    v.dataset.loaded = '0';
    try { v.load(); } catch (e) {} // drop buffered data + free the decoder
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('video[data-lazy-video]').forEach(activate);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { activate(e.target); }
      else { unload(e.target); }
    });
  }, { rootMargin: '250px 0px', threshold: 0.01 });

  function observe(v) { io.observe(v); }

  document.querySelectorAll('video[data-lazy-video]').forEach(observe);

  // Safety net: IntersectionObserver and autoplay are suppressed while a tab is
  // hidden. When the page becomes visible (e.g. opened in a background tab),
  // activate whatever is currently in view so it doesn't sit frozen.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    var pad = 250;
    document.querySelectorAll('video[data-lazy-video]').forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (r.bottom > -pad && r.top < (window.innerHeight + pad)) { activate(v); }
    });
  });

  // Cards injected later (AJAX filters, pagination, quick view) get observed too.
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      for (var i = 0; i < m.addedNodes.length; i++) {
        var n = m.addedNodes[i];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('video[data-lazy-video]')) observe(n);
        if (n.querySelectorAll) n.querySelectorAll('video[data-lazy-video]').forEach(observe);
      }
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
